export default {"src":"/_next/static/media/icon-fb.95b6bc27.svg","height":16,"width":16};